/* eslint-disable linebreak-style */
/* eslint-disable import/no-unresolved */
import { createApp } from "vue";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as labsComponents from "vuetify/labs/components";
import * as directives from "vuetify/directives";
import "@fortawesome/fontawesome-free/css/all.css";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import "@mdi/font/css/materialdesignicons.css";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import config from "./config";
import { sanitizeVehicleText } from "./utils/sanitizeText";

// Plugins
import axios from "axios";
import VueAxios from "vue-axios";
import FlagIcon from "vue-flag-icon";
import TreeView from "vue3-json-viewer";
import "vue3-json-viewer/dist/vue3-json-viewer.css";
import VueQrCodeReader from "vue-qrcode-reader";
import SocialSharing from "vue3-social-sharing";
import StickyHScroll from "./components/common/StickyHScroll.vue";

// i18n (Vue 3 uses createI18n)
import { createI18n } from "vue-i18n";

const locales = {
  en: require("./assets/locales/en.json"),
  sq: require("./assets/locales/sq.json"),
  it: require("./assets/locales/it.json"),
  de: require("./assets/locales/de.json"),
  fr: require("./assets/locales/fr.json"),
  es: require("./assets/locales/es.json"),
};

const i18n = createI18n({
  legacy: false, // 👈 important for Vue 3
  locale: "en",
  messages: locales,
});

// Create Vuetify instance
const vuetify = createVuetify({
  components: {
    ...components,
    ...labsComponents,
  },
  directives,
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: { mdi },
  },
});
// Prevent ResizeObserver loop errors from spamming console
const resizeObserverErr = /ResizeObserver loop (limit exceeded|completed)/;

window.addEventListener("error", (event) => {
  if (resizeObserverErr.test(event.message)) {
    event.stopImmediatePropagation();
  }
});

window.addEventListener("unhandledrejection", (event) => {
  const msg = event.reason?.message || "";
  if (resizeObserverErr.test(msg)) {
    event.stopImmediatePropagation();
  }
});
// Create Vue 3 app
const app = createApp(App);

app.component("StickyHScroll", StickyHScroll);

app.config.globalProperties.$serverUri = config.getServerUri();
app.config.globalProperties.$sanitizeVehicleText = sanitizeVehicleText;
app.config.globalProperties.$scrollToTop = () => {
  window.scroll({ top: 0, left: 0, behavior: "smooth" });
};

// Use plugins
app
  .use(router)
  .use(store)
  .use(VueAxios, axios)
  .use(FlagIcon)
  .use(TreeView)
  .use(VueQrCodeReader)
  .use(SocialSharing)
  .use(i18n)
  .use(vuetify);

app.mount("#app");
